// This import loads the firebase namespace along with all its type information.
import LogType from './log-type-model'

export async function load_logTypes(): Promise<LogType[]> {
  throw 'Not implemented'
}

export async function delete_logType(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_logType(): Promise<LogType> {
  throw 'Not implemented'
}
